
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'

import { mapActions, mapState } from 'vuex'
export default {
name: 'user',
props: [],
components: {
XHeader,
XButton,
Group,
Cell
},
data () {
return {
scrollTag: false,
userPicture: require('@/assets/sass/images/student.png'),
defaultPicture: 'this.src="' + require('@/assets/sass/images/student.png') + '"',
wx: navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
}
},
computed: {
title () {
return this.$route.meta.title
},
...mapState({
token: state => state.token,
flowType: state => state.flowInfo.flowType,
userInfo: state => state.userInfo
})
},
created () {
},
mounted () {
if (this.token && this.userInfo.studentPictureUrl !== null) {
this.userPicture = this.userInfo.studentPictureUrl
}
this.scrollPageHeader()
},
methods: {
...mapActions(['LogoutAction']),
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
login () {
if (!this.token) {
this.$router.push({
name: 'login'
})
}
},
logout () {
this.$api.post('/logout', null,
r => {
this.$store.dispatch('LogoutAction')
},
err => {
this.$vux.toast.text(err.message, 'top')
})
},
scrollPageHeader () {
let _this = this
window.addEventListener('scroll', function () {
let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
if (top < 35) {
_this.scrollTag = false
} else {
_this.scrollTag = true
}
})
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/user/user.vue